export enum JobStatus {
  Pending = 0,
  Available = 1,
  InProgress = 2,
  Error = 3,
  // 4 is the backend's Unknown.
  NoContent = 5,
}

export interface Job {
  id?: string;
  fileType?: string;
  fileName?: string;
  timestamp?: string;
  status: JobStatus;
  statusDetail?: string;
}

/** Mirrors the API's QueueFunctionJobRequest. */
export interface StartDownloadRequest {
  fileType: string;
  recordId: string;
}
